module.exports = "./img/desktop_logo.4a4b098.png";